import * as angular from 'angular';
import { ProductResource } from 'app/_resources/product.resource';

class ProductCompetitionOverviewComponentCtrl implements ng.IController {
    public txId: number;
    public competitions: ProductCompetitionOverviewDto[];
    public runtime: any;
    public loadingFinished: boolean;
    public loggedInTsoRefId: number;
    public errorMessage: string;

    constructor(private productResource: ProductResource) {}

    $onInit() {
        if (this.txId != null) {
            this.productResource.getCompetitions(
                { txId: this.txId },
                (res: ProductCompetitionOverviewDto[]) => {
                    this.competitions = res;
                    this.loadingFinished = true;
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'Failed to load product competitions';
                    this.loadingFinished = true;
                }
            );
        }
    }
}

angular.module('app').component('pkpProductCompetitionOverview', {
    controller: ProductCompetitionOverviewComponentCtrl,
    template: require('app/product/product-competition-overview.component.html'),
    bindings: {
        loadingFinished: '=',
        txId: '<',
        loggedInTsoRefId: '<',
        runtime: '<'
    }
});
